/**
 * nin: loadLanguageOnPage decorator
 * 
 */
import React, {Component} from "react";
import {loadLanguage} from '../common/i18nConfiguration';
import CommonUtil from '../common/CommonUtil';
import { Redirect } from 'react-router-dom';
import { matchPath } from "react-router-dom";
import { ViewPath, VIEW, LocalePath } from "../common/Foundation";
import AccountAction from '../actions/AccountAction';
import SameSite from '../common/SameSite';
import _ from 'lodash';
import cookie from 'react-cookies';

export default function loadLanguageOnPage() {  
    return function(Child) {
      return class extends Component {
         constructor(props) {
          super(props);
            this.preload()
         }
         preload(){
            const lang = this.props.match.params.lang;
            const userLang = CommonUtil.getUserLanguage();
            const __udata = CommonUtil.getUserData() || {}
            if(window.env.isB2B && !window.env.isEnableNewAsianView && this.props.location.pathname.includes('/compact')){
                window.location.href = `/${userLang}/sports`;
                return;
            }
            if (window.env.isEnableOldAsianView) {
                if (!__udata.auth && 
                    !this.props.location.pathname.includes(ViewPath.compactView) && 
                    this.props.location.pathname.includes('sports')
                ){
                    this.pageLoadLang(userLang, false); 
                    let path = `/${userLang}${AccountAction.getCompactViewPath()}/sports`;
                    this.props.history.push(path);
                    return;
                } else if (!this.props.location.pathname.includes(ViewPath.compactView) &&
                    this.props.location.pathname.includes('sports')) {
                    window.location.href = `/${userLang}/sports`;
                    return;
                }
            }

            if (
                matchPath(_.get(this.props.location, 'pathname', ''), {
                path: `/:lang${window.env.leaderBoardPathName}`,
                exact: true}) !== null && __udata.view !== VIEW.COMPACT
            ) {
                const currentLanguage = window.env.langSupports.includes(
                    _.invert(LocalePath)[this.props.match.params.lang]) 
                        ? lang 
                        : userLang;
                this.pageLoadLang(currentLanguage, false);
                return;
            }

            if (__udata.auth && CommonUtil.isMatchLandingPageURL()) {
              const lastView = this.getLastViewFromLocalStorage();
              if (__udata.view === VIEW.ASIAN || lastView === VIEW.ASIAN) {
                window.location.href = `/${CommonUtil.getUserLanguage()}/sports`;
                return;
              } else if (__udata.view === VIEW.STANDARD) {
                window.location.href = CommonUtil.getEuroViewURL(CommonUtil.getCurrentLang());
                return;
              }
            }

            if (!lang && this.props.location.pathname.includes('sports')){
                this.pageLoadLang(userLang, false); 
                let path = `/${userLang}${this.props.location.pathname}`;
                 this.props.history.push(path);
                 return;
             }

            // validate lang if not in supported language it will get from default lang by brand
           const defaultLanguage = CommonUtil.getDefaultLanguageByBrand(
             !window.env.isB2B && __udata.auth && lang !== userLang
               ? userLang
               : lang);
           if (lang !== defaultLanguage) {
             const {search} = this.props.location;
             let path = this.props.location.pathname + ((!_.isUndefined(search) && !_.isNull(search)) ? search : "");
             if (!CommonUtil.isIniFrame()) {
               path = this.replaceLocalePath(path, lang, defaultLanguage);
             }
             this.props.location.pathname = path;
             this.props.history.push(path);
           } else {
             this.pageLoadLang(defaultLanguage, false);
           }
         }

          getLastViewFromLocalStorage = () => {
              return localStorage.getItem('lastView') || "";
          }

          replaceLocalePath = (path, lang, langReplace) => {
            return path.replace(`/${lang}`, `/${langReplace}`);
          }

         render() {
            // Restrict user go to Landing Page after logged in
            const __udata = CommonUtil.getUserData() || {};
            if (__udata.auth && CommonUtil.isMatchLandingPageURL()) {
                  const viewPath = AccountAction.getCompactViewPath();
                  const lastView = this.getLastViewFromLocalStorage();
                  if (__udata.view === VIEW.ASIAN || lastView ===  VIEW.ASIAN || __udata.view === VIEW.STANDARD) {
                    return null
                  }
                  return (
                      <Redirect from='/' to={`/${CommonUtil.getUserLanguage()}${viewPath}/sports`} />
                  );
               
            }

            const arcadiaCookieSuffix = `isArcadia${window.env.arcadiaCookieSuffix}`;
            if (window.env.isB2B && cookie.load(arcadiaCookieSuffix)) {
                const sameSite = SameSite.isSameSiteCompatible ? ` secure=true; SameSite=None;` : ``;
                document.cookie = `${arcadiaCookieSuffix}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=${AccountAction.getSubDomain()};${sameSite}`;
            }
            if(!this.props.match.params.lang && this.props.location.pathname.indexOf('sports') === -1) {               
                return (
                    <Redirect from='/' to={`/${CommonUtil.getUserLanguage()}/`}/>
                );
            }
            else{
                 return (
                    <Child {...this.props} />
                )
            }
          
        }
       pageLoadLang(lang, isFireEvent) {
           if(lang === null) return
           loadLanguage(lang, isFireEvent);
           //this.state = { currentLang: lang };
           document.body.classList.add(CommonUtil.toLocaleCode(lang));
           document.documentElement.classList.add(CommonUtil.toLocaleCode(lang));
           
        }
        componentWillUpdate(nextProps, nextState) {
            let nextLang = nextProps.match.params.lang;
            let currentLang = this.props.match.params.lang;
            if(currentLang !== nextLang){
                this.pageLoadLang(nextLang, true);
                document.body.classList.remove(CommonUtil.toLocaleCode(currentLang)); 
                document.documentElement.classList.remove(CommonUtil.toLocaleCode(currentLang));              
            }
        }

        componentDidUpdate(prevProps, prevState) {
             //window.fireEvent(EVENT.BODY_CENTER_LOADING_DONE)
        }
        
     }
 }
}


// WEBPACK FOOTER //
// ./src/app/decorator/loadLanguageOnPage.js